import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-info',
  templateUrl: './file-info.component.html',
  styleUrls: ['./file-info.component.css']
})
export class FileInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


  /**
   * 
   */
  fileEdit() {

  }

  fileLink() {

  }

  fileDownload() {
    
  }
  

}
